import { IFetchState } from "itsf-ui-common";
import { IUsageSummary } from "./interface/IUsageSummary";
import { Fragment } from "react";
import { UsageCarousel } from "./UsageCarousel/UsageCarousel";
import { ECarouselType } from "./UsageCarousel/ECarouselType";
import { CarouselItem } from "./UsageCarousel/CarouselItem";
import { HandleErrorAndLoading } from "@common/HandleErrorAndLoading/HandleErrorAndLoading";

interface IParams {
    selectedTimePeriod: string;
    usageSummaryList: IUsageSummary[];
    getUsageSummaryState: IFetchState;
    refreshUsageSummary(): void;
}

export const UsageSummary = (props: IParams) => {
    const { usageSummaryList, getUsageSummaryState, refreshUsageSummary } = props;
    const showMobileCarousel = usageSummaryList && usageSummaryList?.length > 3;

    return (
        <div className="usage-summary">
            <HandleErrorAndLoading
                error={getUsageSummaryState.error}
                isLoading={getUsageSummaryState.isLoading}
                retryFetch={refreshUsageSummary}
            >
                <div className="desktop-only">
                    {usageSummaryList && usageSummaryList.length > 0 && (
                        <UsageCarousel carouselType={ECarouselType.DESKTOP} usageSummaryList={usageSummaryList} />
                    )}
                </div>
                <div className="mobile-only">
                    {usageSummaryList && usageSummaryList.length > 0 && (
                        <Fragment>
                            {showMobileCarousel && (
                                <UsageCarousel
                                    carouselType={ECarouselType.MOBILE}
                                    usageSummaryList={usageSummaryList}
                                />
                            )}
                            {!showMobileCarousel && (
                                <div aria-label="usage summary items" className="embla no-carousel">
                                    {usageSummaryList.map((usageSummary) => (
                                        <div className="slide-content-wrapper" key={usageSummary.usageType}>
                                            <CarouselItem usageSummary={usageSummary} />
                                        </div>
                                    ))}
                                </div>
                            )}
                        </Fragment>
                    )}
                </div>
            </HandleErrorAndLoading>
        </div>
    );
};
